import { Injectable } from '@angular/core';

import { CheckoutStorageService } from '@bytel/checkout';

import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { ObjectOfString } from '../interfaces/checkout.interface';
import { AppService } from './app.services';
import { CheckoutOauth2ResourcesService } from './oauth2-ressources.service';

export interface IPortabilityControl {
    codeRetour: string;
    idPanier: string;
    idPorta: string;
    msgRetour: string;
    nap: string;
    offreAdsls: number[];
    offreFtths: number[];
    offreThds: number[];
    offreVdsls: number[];
    typeDegroupage: string;
}

export interface IPortaChoice {
    [key: number]: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class PortabilityService {
    public portaChoice$: Observable<IPortaChoice>;

    private _portaSubject: BehaviorSubject<IPortaChoice> = new BehaviorSubject<IPortaChoice>({ 0: true });
    private ID_PORTA_KEY: string = 'idsPorta';

    public constructor(
        private oauthService: CheckoutOauth2ResourcesService,
        protected checkoutStorage: CheckoutStorageService,
        private appService: AppService,
    ) {
        this.portaChoice$ = this._portaSubject.asObservable();
    }

    public checkPortability(phoneNumber: string, codeRio: string): Observable<IPortabilityControl> {
        const body: ObjectOfString = {
            noTelephoneAPorter: phoneNumber.replace('0', '+33'),
            codeRio,
        };

        this.appService.formStatusSubject.next({ ...this.appService.formStatusSubject.getValue(), loading: true });

        return this.oauthService
            .useSalesApi()
            .ventes()
            .controlePortabilite()
            .post(body)
            .pipe(
                tap((porta: IPortabilityControl) => {
                    this._addIdPorta(porta);
                }),
                finalize(() => {
                    this.appService.formStatusSubject.next({
                        ...this.appService.formStatusSubject.getValue(),
                        loading: false,
                    });
                }),
            );
    }

    public setPortability(value: boolean, quoteIndex: number = 0): void {
        const portaData = this._portaSubject.value;
        portaData[quoteIndex] = value;
        this._portaSubject.next(portaData);
    }

    private _addIdPorta(porta: IPortabilityControl): void {
        if (porta?.idPanier && porta?.idPorta) {
            const idsPorta = this.checkoutStorage.get(this.ID_PORTA_KEY) || {};
            idsPorta[porta.idPanier] = porta.idPorta;
            this.checkoutStorage.set(this.ID_PORTA_KEY, idsPorta);
        }
    }
}
